export default function configurationReducer(state, action) {
  switch (action.type) {
    case 'GET_ALL_ZONES':
      return {
        ...state,
        zones: action.payload,
        loading: false,
      }
    case 'ADD_ZONE':
      return {
        ...state,
        zones: [action.payload, ...state.zones],
      }
    case 'ADD_REGION':
      return {
        ...state,
        regions: [action.payload, ...state.regions],
      }
    case 'ADD_STATE':
      return {
        ...state,
        states: [action.payload, ...state.states],
      }
    case 'ADD_DISTRICT':
      return {
        ...state,
        district: [action.payload, ...state.district],
      }
    case 'ADD_CITY':
      return {
        ...state,
        city: [action.payload, ...state.city],
      }
    case 'ADD_AREA':
      return {
        ...state,
        areas: [action.payload, ...state.areas],
      }
    case 'ADD_STORE':
      return {
        ...state,
        stores: [action.payload, ...state.stores],
      }

    case 'EDIT_REGION':
      const updatedRegion = action.payload

      const updatedRegions = state.regions.map((region) => {
        if (region._id === updatedRegion._id) {
          return updatedRegion
        }
        return region
      })

      return {
        ...state,
        regions: updatedRegions,
      }
    case 'EDIT_STATE':
      const updatedState = action.payload

      const updatedStates = state.states.map((state) => {
        if (state._id === updatedState._id) {
          return updatedState
        }
        return state
      })

      return {
        ...state,
        states: updatedStates,
      }
    case 'EDIT_DISTRICT':
      const updatedDistrict = action.payload

      const updatedDistricts = state.district.map((district) => {
        if (district._id === updatedDistrict._id) {
          return updatedDistrict
        }
        return district
      })

      return {
        ...state,
        district: updatedDistricts,
      }
    case 'EDIT_CITY':
      const updatedCity = action.payload

      const updatedCitys = state.city.map((zone) => {
        if (zone._id === updatedCity._id) {
          return updatedCity
        }
        return zone
      })

      return {
        ...state,
        city: updatedCitys,
      }
    case 'EDIT_AREA':
      const updatedArea = action.payload

      const updatedAreas = state.areas.map((area) => {
        if (area._id === updatedArea._id) {
          return updatedArea
        }
        return area
      })

      return {
        ...state,
        areas: updatedAreas,
      }
    case 'EDIT_STORE':
      const updatedStore = action.payload

      const updatedStores = state.stores.map((store) => {
        if (store._id === updatedStore._id) {
          return updatedStore
        }
        return store
      })

      return {
        ...state,
        stores: updatedStores,
      }
    case 'EDIT_ZONE':
      const updatedZone = action.payload

      const updatedZones = state.zones.map((zone) => {
        if (zone._id === updatedZone._id) {
          return updatedZone
        }
        return zone
      })

      return {
        ...state,
        zones: updatedZones,
      }
    case 'REMOVE_ZONE':
      return {
        ...state,
        zones: state.zones.filter((zone) => zone._id !== action.payload),
      }
    case 'REMOVE_LEAD':
      return {
        ...state,
        leads: state.leads.filter((lead) => lead._id !== action.payload),
      }
    case 'REMOVE_REGION':
      return {
        ...state,
        regions: state.regions.filter((data) => data._id !== action.payload),
      }
    case 'REMOVE_STATE':
      return {
        ...state,
        states: state.states.filter((data) => data._id !== action.payload),
      }
    case 'REMOVE_DISTRICT':
      return {
        ...state,
        district: state.district.filter((data) => data._id !== action.payload),
      }
    case 'REMOVE_CITY':
      return {
        ...state,
        city: state.city.filter((data) => data._id !== action.payload),
      }
    case 'REMOVE_AREA':
      return {
        ...state,
        areas: state.areas.filter((data) => data._id !== action.payload),
      }
    case 'REMOVE_STORE':
      return {
        ...state,
        stores: state.stores.filter((data) => data._id !== action.payload),
      }

    // CHANNEL TYPE
    case 'GET_ALL_CHANNEL_TYPES':
      return {
        ...state,
        channelTypes: action.payload,
        loading: false,
      }
    case 'ADD_CHANNEL_TYPE':
      return {
        ...state,
        channelTypes: [action.payload, ...state.channelTypes],
      }
    case 'EDIT_CHANNEL_TYPE':
      const updatedChannelType = action.payload

      const updatedChannelTypes = state.channelTypes.map((channelType) => {
        if (channelType._id === updatedChannelType._id) {
          return updatedChannelType
        }
        return channelType
      })

      return {
        ...state,
        channelTypes: updatedChannelTypes,
      }
    case 'REMOVE_CHANNEL_TYPE':
      return {
        ...state,
        channelTypes: state.channelTypes.filter((channelType) => channelType._id !== action.payload),
      }

    // TARGET TYPE
    case 'GET_ALL_TARGET_TYPES':
      return {
        ...state,
        targetTypes: action.payload,
        loading: false,
      }
    case 'ADD_TARGET_TYPE':
      return {
        ...state,
        targetTypes: [action.payload, ...state.targetTypes],
      }
    case 'EDIT_TARGET_TYPE':
      const updatedTargetType = action.payload

      const updatedTargetTypes = state.targetTypes.map((targetType) => {
        if (targetType._id === updatedTargetType._id) {
          return updatedTargetType
        }
        return targetType
      })

      return {
        ...state,
        targetTypes: updatedTargetTypes,
      }
    case 'REMOVE_TARGET_TYPE':
      return {
        ...state,
        targetTypes: state.targetTypes.filter((targetType) => targetType._id !== action.payload),
      }

    // TEMPLATE CATEGORY
    case 'GET_ALL_TEMPLATE_CATEGORY':
      return {
        ...state,
        templateCategory: action.payload,
        loading: false,
      }
    case 'ADD_TEMPLATE_CATEGORY':
      return {
        ...state,
        templateCategory: [action.payload, ...state.templateCategory],
      }
    case 'EDIT_TEMPLATE_CATEGORY':
      const updatedTemplateCategory = action.payload

      const updatedTemplateCategorys = state.templateCategory.map((targetType) => {
        if (targetType._id === updatedTemplateCategory._id) {
          return updatedTemplateCategory
        }
        return targetType
      })

      return {
        ...state,
        templateCategory: updatedTemplateCategorys,
      }
    case 'REMOVE_TEMPLATE_CATEGORY':
      return {
        ...state,
        templateCategory: state.templateCategory.filter((targetType) => targetType._id !== action.payload),
      }

    // TARGET
    case 'GET_ALL_TARGET':
      return {
        ...state,
        targets: action.payload,
        loading: false,
      }
    case 'ADD_TARGET':
      return {
        ...state,
        targets: [action.payload, ...state.targets],
      }
    case 'EDIT_TARGET':
      const updatedTarget = action.payload

      const updatedTargets = state.targets.map((targetType) => {
        if (targetType._id === updatedTarget._id) {
          return updatedTarget
        }
        return targetType
      })

      return {
        ...state,
        targets: updatedTargets,
      }
    case 'REMOVE_TARGET':
      return {
        ...state,
        targets: state.targets.filter((targetType) => targetType._id !== action.payload),
      }
    case 'REMOVE_POSITION':
      return {
        ...state,
        positions: state.positions.filter((data) => data._id !== action.payload),
      }
    case 'REMOVE_LEAVETYPE':
      return {
        ...state,
        leaveType: state.leaveType.filter((data) => data._id !== action.payload),
      }
    case 'REMOVE_LEADTYPE':
      return {
        ...state,
        leadType: state.leadType.filter((data) => data._id !== action.payload),
      }
    case 'GET_ALL_REGION':
      return {
        ...state,
        regions: action.payload,
        loading: false,
      }
    case 'GET_ALL_ZONE':
      return {
        ...state,
        zone: action.payload,
        loading: false,
      }
    case 'GET_ALL_STATES':
      return {
        ...state,
        states: action.payload,
        loading: false,
      }
    case 'GET_ALL_POSITION':
      return {
        ...state,
        positions: action.payload,
        loading: false,
      }
    case 'GET_ALL_DISTRICT':
      return {
        ...state,
        district: action.payload,
        loading: false,
      }
    case 'GET_ALL_CITY':
      return {
        ...state,
        city: action.payload,
        loading: false,
      }
    case 'GET_ALL_AREA':
      return {
        ...state,
        areas: action.payload,
        loading: false,
      }
    case 'GET_ALL_STORE':
      return {
        ...state,
        stores: action.payload,
        loading: false,
      }
    case 'GET_ALL_LEAVETYPE':
      return {
        ...state,
        leaveType: action.payload,
        loading: false,
      }
    case 'GET_ALL_LEADTYPE':
      return {
        ...state,
        leadType: action.payload,
        loading: false,
      }
    case 'GET_EMPLOYEE_ATTENDANCE':
      return {
        ...state,
        employeeAttendance: action.payload,
        loading: false,
      }
    case 'GET_ALL_TOTAL_LEAVE':
      return {
        ...state,
        totalLeaves: action.payload,
        loading: false,
      }
    case 'REMOVE_EMPLOYEE_ATTENDANCE':
      return {
        ...state,
        employeeAttendance: state.employeeAttendance.filter((data) => data._id !== action.payload),
      }

    case 'GET_ALL_TAX':
      return {
        ...state,
        taxes: action.payload,
        loading: false,
      }
    case 'REMOVE_TAX':
      return {
        ...state,
        taxes: state.taxes.filter((data) => data._id !== action.payload),
      }

    case 'GET_ALL_SCHEME':
      return {
        ...state,
        schemes: action.payload,
        loading: false,
      }
    case 'REMOVE_SCHEME':
      return {
        ...state,
        schemes: state.schemes.filter((data) => data._id !== action.payload),
      }

    case 'GET_ALL_LEADTYPE_CONVERSION':
      return {
        ...state,
        leadTypeConversions: action.payload,
        loading: false,
      }
    case 'REMOVE_LEADTYPE_CONVERSION':
      return {
        ...state,
        leadTypeConversions: state.leadTypeConversions.filter((data) => data._id !== action.payload),
      }
    case 'GET_ALL_SALES_CHANNEL_TYPE':
      return {
        ...state,
        salesChannelTypes: action.payload,
        loading: false,
      }
    case 'REMOVE_SALES_CHANNEL_TYPE':
      return {
        ...state,
        salesChannelTypes: state.salesChannelTypes.filter((data) => data._id !== action.payload),
      }
    case 'GET_ALL_LEADSOURCE':
      return {
        ...state,
        leadSources: action.payload,
        loading: false,
      }
    case 'REMOVE_LEADSOURCE':
      return {
        ...state,
        leadSources: state.leadSources.filter((data) => data._id !== action.payload),
      }
    case 'GET_ALL_CUSTOMERTYPE':
      return {
        ...state,
        customerTypes: action.payload,
        loading: false,
      }
    case 'REMOVE_CUSTOMERTYPE':
      return {
        ...state,
        customerTypes: state.customerTypes.filter((data) => data._id !== action.payload),
      }

    case 'REMOVE_TOTAL_LEAVE':
      return {
        ...state,
        totalLeaves: state.totalLeaves.filter((data) => data._id !== action.payload),
      }

    case 'GET_ALL_HOLIDAY':
      return {
        ...state,
        holidays: action.payload,
        loading: false,
      }
    case 'REMOVE_HOLIDAY':
      return {
        ...state,
        holidays: state.holidays.filter((data) => data._id !== action.payload),
      }

    default:
      return state
  }
}
